import { CentraCheckoutApiMappers } from "@made-people/grease-centra";

export const mmProductBadges: CentraCheckoutApiMappers["centraCheckoutApiProductToGreaseProductBadges"] =
  (product) => {
    return Object.values(product.pr_badge ?? {}).map((badge) => {
      return {
        label: badge,
        badgeType: "unknown",
      };
    });
  };
